import {calculateErrorMessage} from 'common/helpers'

import {initialWalkthroughState} from '../core/DynamicWalkthroughContext'
import {cleanupAllWalkthroughAttributes} from './walkthroughDom'

export type CleanupParams = {
  refs?: any
  helpers?: any
  setState?: ((s: any) => void) | null
  reason?: string
}

export function performFullWalkthroughCleanup(params: CleanupParams = {}) {
  const {refs, helpers, setState} = params
  try {
    cleanupAllWalkthroughAttributes()
  } catch (e) {
    calculateErrorMessage(e)
  }

  try {
    sessionStorage.removeItem('pending-walkthrough')
  } catch (e) {
    calculateErrorMessage(e)
  }

  try {
    if (refs) {
      try {
        if (refs.walkthroughInProgress) refs.walkthroughInProgress.current = false
      } catch (e) {
        calculateErrorMessage(e)
      }
      try {
        if (refs.postNavigationInProgress) refs.postNavigationInProgress.current = false
      } catch (e) {
        calculateErrorMessage(e)
      }
      try {
        if (refs.modalOpenedByWalkthrough) refs.modalOpenedByWalkthrough.current = false
      } catch (e) {
        calculateErrorMessage(e)
      }
    }
  } catch (e) {
    calculateErrorMessage(e)
  }

  try {
    if (helpers) {
      try {
        if (helpers.setPortalPassThrough) helpers.setPortalPassThrough(false)
      } catch (e) {
        calculateErrorMessage(e)
      }
      try {
        if (helpers.setIsTransitioning) helpers.setIsTransitioning(false)
      } catch (e) {
        calculateErrorMessage(e)
      }
    }
  } catch (e) {
    calculateErrorMessage(e)
  }

  try {
    if (setState) setState(initialWalkthroughState)
  } catch (e) {
    calculateErrorMessage(e)
  }

  try {
    window.dispatchEvent(new CustomEvent('dynamic-walkthrough-force-cleanup'))
  } catch (e) {
    calculateErrorMessage(e)
  }
}

export default performFullWalkthroughCleanup
